import * as i0 from '@angular/core';
import { Component, ViewEncapsulation, Input, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

class UxMarkerComponent {
    constructor() {
        this.e2eAttr = 'ux-a-marker';
    }
}
/** @nocollapse */ UxMarkerComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.0.3", ngImport: i0, type: UxMarkerComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
/** @nocollapse */ UxMarkerComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.0.3", type: UxMarkerComponent, selector: "ux-a-marker", inputs: { styleClass: "styleClass", typeClass: "typeClass", e2eAttr: "e2eAttr" }, ngImport: i0, template: "<div class=\"ux-a-marker {{styleClass}}\" attr.data-e2e=\"{{ e2eAttr }}\">\n    <span class=\"ux-icon ux-icon-circle ux-a-marker__icon ux-u-color-{{typeClass}}\"></span>\n</div>\n", styles: [".ux-a-marker__icon{color:var(--eui-base-color-grey-80);font-size:var(--eui-base-font-size)}.ux-a-marker--small{padding:var(--eui-base-spacing-xs)}.ux-a-marker--large{padding:var(--eui-base-spacing-m)}\n"], encapsulation: i0.ViewEncapsulation.None });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.0.3", ngImport: i0, type: UxMarkerComponent, decorators: [{
            type: Component,
            args: [{ selector: 'ux-a-marker', encapsulation: ViewEncapsulation.None, template: "<div class=\"ux-a-marker {{styleClass}}\" attr.data-e2e=\"{{ e2eAttr }}\">\n    <span class=\"ux-icon ux-icon-circle ux-a-marker__icon ux-u-color-{{typeClass}}\"></span>\n</div>\n", styles: [".ux-a-marker__icon{color:var(--eui-base-color-grey-80);font-size:var(--eui-base-font-size)}.ux-a-marker--small{padding:var(--eui-base-spacing-xs)}.ux-a-marker--large{padding:var(--eui-base-spacing-m)}\n"] }]
        }], propDecorators: { styleClass: [{
                type: Input
            }], typeClass: [{
                type: Input
            }], e2eAttr: [{
                type: Input
            }] } });
class UxMarkerComponentModule {
}
/** @nocollapse */ UxMarkerComponentModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.0.3", ngImport: i0, type: UxMarkerComponentModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
/** @nocollapse */ UxMarkerComponentModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "15.0.3", ngImport: i0, type: UxMarkerComponentModule, declarations: [UxMarkerComponent], imports: [CommonModule], exports: [UxMarkerComponent] });
/** @nocollapse */ UxMarkerComponentModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "15.0.3", ngImport: i0, type: UxMarkerComponentModule, imports: [CommonModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.0.3", ngImport: i0, type: UxMarkerComponentModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule],
                    exports: [UxMarkerComponent],
                    declarations: [UxMarkerComponent]
                }]
        }] });

/**
 * Generated bundle index. Do not edit.
 */

export { UxMarkerComponent, UxMarkerComponentModule };
